import React, { useState } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Typography,
  Chip,
  CircularProgress,
  Alert,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useProject } from '../contexts/ProjectContext';
import { useAuth } from '../auth/useAuth';

const ProjectSelector = () => {
  const { 
    projects, 
    activeProject, 
    loading, 
    error, 
    switchProject 
  } = useProject();
  
  const { user } = useAuth();
  const [switching, setSwitching] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleProjectChange = async (event) => {
    const projectId = event.target.value;
    
    if (projectId === activeProject?.id) {
      return;
    }
    
    setSwitching(true);
    try {
      await switchProject(projectId);
    } catch (error) {
      console.error('Error switching project:', error);
    } finally {
      setSwitching(false);
    }
  };


  if (error) {
    return (
      <Alert severity="error" sx={{ minWidth: 200 }}>
        {error}
      </Alert>
    );
  }

  if (loading) {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <CircularProgress size={20} />
        <Typography variant="body2">טוען פרויקטים...</Typography>
      </Box>
    );
  }

  // עבור סדרנים ללא פרויקטים - הסתר לגמרי
  if (user?.role === 'bus_coordinator' && projects.length === 0) {
    return null;
  }

  // עבור סדרנים עם פרויקט אחד - הצג כ-readonly
  if (user?.role === 'bus_coordinator' && projects.length === 1) {
    return (
      <Box display="flex" alignItems="center" gap={isMobile ? 1 : 2}>
        {!isMobile && (
          <Typography variant="body2" color="text.primary">
            פרויקט:
          </Typography>
        )}
        <Chip
          label={activeProject?.name || projects[0]?.name}
          color="primary"
          variant="filled"
          size={isMobile ? "small" : "medium"}
        />
      </Box>
    );
  }

  if (projects.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        אין פרויקטים זמינים
      </Typography>
    );
  }



  return (
    <Box display="flex" alignItems="center" gap={isMobile ? 1 : 2}>
      {!isMobile && (
        <Typography variant="body2" color="text.secondary">
          פרויקט פעיל:
        </Typography>
      )}
      
      <FormControl size="small" sx={{ minWidth: isMobile ? 120 : 200 }}>
        <Select
          value={activeProject?.id === 'all' ? 'all' : activeProject?.id === 'unassigned' ? 'unassigned' : activeProject?.id || ''}
          onChange={handleProjectChange}
          disabled={switching}
          displayEmpty
        >
          <MenuItem value="" disabled>
            בחר פרויקט
          </MenuItem>
          
          {/* אפשרויות נוספות רק למנהלים */}
          {user?.role === 'manager' && (
            <>
              <MenuItem value="all">
                כל הפרויקטים
              </MenuItem>

              <MenuItem value="unassigned">
                לא משויכים
              </MenuItem>
            </>
          )}
          
          {projects.map((project) => (
            <MenuItem 
              key={project.id} 
              value={project.id}
            >
              {project.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      {switching && (
        <CircularProgress size={16} />
      )}
    </Box>
  );
};

export default ProjectSelector;
